module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_f_albino.0b7ebaec.png";